'use es6';

import I18n from 'I18n';
import { createSelectorCreator, defaultMemoize } from 'reselect';
import get from 'transmute/get';
import { is, List } from 'immutable';
import { getBookableDays, getListOfDays, getConfiguredAvailableTimeRanges as getConfiguredAvailableTimeRangesUtil } from 'MeetingsBase/utils/utils';
import { getCurrentTime } from 'MeetingsLib/selectors/RESTParamSelectors';
import { getFlexibleIntervalStartTimes } from 'MeetingsBase/utils/TimeRangeListUtils';
import { getCustomParams as getCustomParamsSelector, getUserTimezone, getEvent, getMeetingLength, getOffline, getStartTimeIntervalMilliseconds } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getEmbedded } from 'MeetingsLib/selectors/RESTParamSelectors';
import { ONE_DAY } from 'MeetingsBase/constants/dates';
import AvailabilityMilliseconds from 'MeetingsBase/models/AvailabilityMilliseconds';
import getIn from 'transmute/getIn';
var createSelector = createSelectorCreator(defaultMemoize, is);
var getTroubleshooting = get('troubleshooting');
export var shouldAllowTroubleshootMode = get('allowTroubleshootMode');
export var userLoggedInToValidPortal = function userLoggedInToValidPortal(state) {
  var portalIdFromUserProfile = get('portalId', state);
  var portalIdFromAuth = getIn(['portalAuth', 'portal', 'portal_id'], state);
  return portalIdFromUserProfile && portalIdFromAuth && portalIdFromUserProfile === portalIdFromAuth;
};
export var canTroubleshootSelector = createSelector([getEmbedded, getOffline, shouldAllowTroubleshootMode, userLoggedInToValidPortal], function (embedded, offline, allowTroubleshootMode, loggedIn) {
  return !embedded && !offline && allowTroubleshootMode && loggedIn || false;
});
export var isTroubleshootingSelector = createSelector([getTroubleshooting, canTroubleshootSelector], function (_ref, canTroubleshoot) {
  var troubleshootingActive = _ref.active;
  return troubleshootingActive && canTroubleshoot;
});
export var getConfiguredAvailableTimeRanges = createSelector([isTroubleshootingSelector, getCustomParamsSelector, getCurrentTime], function (troubleshooting, customParams, currentTime) {
  if (!troubleshooting) {
    return List();
  }

  return getConfiguredAvailableTimeRangesUtil(AvailabilityMilliseconds.fromAvailability(customParams.availability), customParams.weeksToAdvertise, customParams.customAvailabilityStartDate, customParams.customAvailabilityEndDate, customParams.timezone, currentTime);
});
export var getConfiguredPossibleStartTimes = createSelector([isTroubleshootingSelector, getStartTimeIntervalMilliseconds, getConfiguredAvailableTimeRanges, getEvent], function (isTroubleShooting, startTimeIntervalMilliseconds, configuredAvailableTimeRanges, event) {
  if (!isTroubleShooting) {
    return List();
  }

  return getFlexibleIntervalStartTimes(configuredAvailableTimeRanges, event.duration, startTimeIntervalMilliseconds);
});
export var getTroubleshootTimesByDuration = createSelector([getTroubleshooting], function (troubleshooting) {
  return getIn(['data', 'troubleshootTimesByDuration'], troubleshooting) || {};
});
export var getTroubleshootTimesForSelectedDuration = createSelector([getTroubleshootTimesByDuration, getMeetingLength], function (timesByDuration, duration) {
  return getIn([duration, 'troubleshootTimes'], timesByDuration) || List();
});
export var getTroubleshootTimesForSelectedDurationByDay = createSelector([getTroubleshootTimesForSelectedDuration, getUserTimezone], function (troubleshootTimes, userTimezone) {
  return troubleshootTimes ? List(troubleshootTimes).groupBy(function (troubleshootTime) {
    return I18n.moment(troubleshootTime.startMillisUtc).tz(userTimezone).format('YYYY-MM-DD');
  }) : List();
}); // Date selectors

export var getTroubleshootStartTimesForSelectedDate = createSelector([getTroubleshootTimesForSelectedDurationByDay, getEvent], function (troubleshootTimesForSelectedDurationByDay, event) {
  return troubleshootTimesForSelectedDurationByDay.get(event.dateString) || List();
});
export var getConfiguredBookableDates = createSelector([isTroubleshootingSelector, getCustomParamsSelector, getCurrentTime], function (troubleshooting, customParams, currentTime) {
  if (!troubleshooting) {
    return List();
  }

  var weeksToAdvertise = customParams.weeksToAdvertise,
      customAvailabilityStartDate = customParams.customAvailabilityStartDate,
      customAvailabilityEndDate = customParams.customAvailabilityEndDate;
  return getBookableDays(weeksToAdvertise, customAvailabilityStartDate, customAvailabilityEndDate, currentTime).map(function (startDayTimestamp) {
    return I18n.moment.utc(startDayTimestamp).format('YYYY-MM-DD');
  });
});
export var getConfiguredAvailabilityByDate = createSelector([getConfiguredPossibleStartTimes, getUserTimezone], function (configuredPossibleStartTimes, userTimezone) {
  return configuredPossibleStartTimes.groupBy(function (startTime) {
    return I18n.moment(startTime).tz(userTimezone).format('YYYY-MM-DD');
  });
});
export var getMinimumNoticeTimeBusyDays = createSelector([getCustomParamsSelector, getCurrentTime], function (customParams, currentTime) {
  var minimumNoticeTime = customParams.minimumNoticeTime;

  if (minimumNoticeTime < ONE_DAY) {
    return List();
  }

  var numberOfDays = Math.floor(minimumNoticeTime / ONE_DAY);
  var listOfDays = getListOfDays(I18n.moment(currentTime), numberOfDays);
  return listOfDays.map(function (timestamp) {
    return I18n.moment(timestamp).format('YYYY-MM-DD');
  });
});